import React from "react";
import Table from "../../../parts/table/Table";
import {
  EyeIcon,
  LockClosedIcon,
  LockOpenIcon,
  PencilIcon,
} from "@heroicons/react/outline";
import { Link } from "react-router-dom";


function HasilKuisTable(props) {
  console.log(props.data);
  const columns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Dibuat",
      accessor: "tanggal_buka",
    },
    {
      Header: "Diposting",
      accessor: "tanggal_tutup",
    },
    {
      Header: "Kuesioner-ku",
      accessor: "judul",
    },
    {
      Header: "Sifat",
      id: "sifat",
      Cell: ({ row }) => {
        if (row.original.tipe === 0) {
          return (
            <button onClick={() => console.log(row)}>
              <LockOpenIcon className="h-6 w-6 text-green-600" />
            </button>
          );
        } else {
          return (
            <button onClick={() => console.log(row)}>
              <LockClosedIcon className="h-6 w-6" />
            </button>
          );
        }
      },
    },
    {
      Header: "Undangan",
      accessor: "undang_count",
    },
    {
      Header: "Pendaftar",
      accessor: "daftar_count",
    },
    {
      Header: "Responden",
      accessor: "data_responden_count",
    },
    {
      Header: "Belum",
      accessor: "scoin_paid_count",
    },
    {
      Header: "Selesai",
      accessor: "jawaban_sent_count",
    },
    {
      Header: "Scoin",
      accessor: "scoin",
    },
    {
      Header: "Hasil",
      id: "tipe",
      Cell: ({ row }) => {
        let link = "/hasil-kuis";
        if (row.original.tipe === 0) {
          link = `/hasil-kuesioner/${row.original.id}`;
        } else if (row.original.tipe === 2) {
          link = `/hasil-kuesioner/${row.original.id}`;
        } else {
          link = `/hasil-kuesioner/${row.original.id}`;
        }
        return (
          <Link
            to={link}
            className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white"
          >
            <EyeIcon className="h-6 w-6" />
          </Link>
        );
      },
    },
  ];
  let data = props.data ?? [];
  return (
    <>
      <Table columns={columns} data={data} />
    </>
  );
}

HasilKuisTable.propTypes = {};

export default HasilKuisTable;
